import { put, call, fork, all, takeLatest, select } from "redux-saga/effects";
import * as types from "~/store/contact/contactType";
import * as apiPostContact from "~/store/contact/contactApi";
import { getBaseUrl } from "~/utils/getBaseUrl";
import { openToast } from "~/components/common/molecules/ToastNotification";

function* requestPostContact({ contact }) {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const response = yield call(
      apiPostContact.apiPostContact,
      baseUrl,
      contact
    );
    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    if (response) {
      const { data } = response;
      yield put({ type: types.POST_CONTACT_SUCCESS, data });
      openToast("Bạn đã gửi yêu cầu thành công!");
    }
  } catch (error) {
    yield put({ type: types.POST_CONTACT_FAIL, error });
  }
}

function* watchRequestPostContact() {
  yield takeLatest(types.POST_CONTACT, requestPostContact);
}

export default function* root() {
  yield all([fork(watchRequestPostContact)]);
}
